import { BrowserModule } from '@angular/platform-browser';
import localeEs from '@angular/common/locales/es';
import { NgModule, ErrorHandler, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { JL } from 'jsnlog';
import { AppComponent } from './app.component';
import { registerLocaleData } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthorizeInterceptor } from './core/authorize.interceptor';
import { NavComponent } from './core/nav/nav.component';
import { ResetPasswordRequestComponent } from './core/components/reset-password-request/reset-password-request.component';
import { IntlModule } from '@progress/kendo-angular-intl';
import '@progress/kendo-angular-intl/locales/es/all';
import { AuthGuard } from './core/guards/auth.guards';
import { SharedService } from './shared/shared.service';

registerLocaleData(localeEs, 'es');

export class UncaughtExceptionHandler implements ErrorHandler {
  handleError(error: any) {
    JL().fatalException('Uncaught Exception', error);
  }
}




@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    AppRoutingModule,
    SharedModule,
    CoreModule,
    BrowserAnimationsModule,
    IntlModule
  ],
  providers: [
    AuthGuard,
    { provide: LOCALE_ID, useValue: "es-ES" },
    { provide: HTTP_INTERCEPTORS, useClass: AuthorizeInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: (appConfigProvider: SharedService) => {
        return () => appConfigProvider.loadConfig();
      },
      multi: true,
      deps: [SharedService]
    },
    //{ provide: 'API_URI', useValue: "http://api.alvo-ill.org/api" }
    { provide: ErrorHandler, useClass: UncaughtExceptionHandler }
  ],
  entryComponents: [
    NavComponent, ResetPasswordRequestComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
